import { render, staticRenderFns } from "./editLabelgroup.vue?vue&type=template&id=5a75e22f&scoped=true"
import script from "./editLabelgroup.vue?vue&type=script&lang=js"
export * from "./editLabelgroup.vue?vue&type=script&lang=js"
import style0 from "./editLabelgroup.vue?vue&type=style&index=0&id=5a75e22f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a75e22f",
  null
  
)

export default component.exports